import Login from "../components/pages/login";

import CambiarPin from "../components/pages/login/CambiarPin";

// import Calender from "./components/calender/Calender";
import Profile from "../components/pages/login/Profile";
import EditProfile from "../components/pages/login/EditProfile";
import OlvidePin from "../components/pages/login/OlvidePin";
import Unauthorized from "../pages/Unauthorized"; 

export default [
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/restablecer-pin",
        element: <OlvidePin />,
    },
    {
        path: "/cambiar-pin",
        element: <CambiarPin />,
    },
    {
        path: "/profile",
        element: <Profile />,
    },
    {
        path: "/editprofile",
        element: <EditProfile />,
    },
    {
        path: "/UnAuthorized",
        element: <Unauthorized />,
    }

]